<!-- Content Header (Page header) -->
<section class="content-header">
    <div class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
           
            <div class="col-sm-6">
              <a routerLink="/settings/add-user" class="btn btn-success pull-left" class="btn btn-success"><i
                class="fa fa-plus-circle" aria-hidden="true">&nbsp;</i>New User</a>
            </div><!-- /.col -->
           
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item"><a routerLink="/"><i class="nav-icon fas fa-tachometer-alt"></i>&nbsp;Dashboard</a></li>
                <li class="breadcrumb-item active">Users List</li>
              </ol>
            </div><!-- /.col -->
          </div><!-- /.row -->
        </div><!-- /.container-fluid -->
    </div>
    <div class="row">
        <div class="col-md-8">
            <div class="row">
               
            </div>
        </div>
        <div class="col-md-4">
          <div class="row">
              <div class="col">
                  <input type="text" class="form-control" placeholder="Type name here to search" (input)="onSearchTextChange($event)">
              </div>
          </div>
        </div>
    </div>
    </section>

    <!--Loading Spinner-->
    <div *ngIf="isProcessing">
      <app-spinner></app-spinner>
    </div>

      <!-- /.content-header -->
    <section class="content">
      <div class="container-fluid">
      <div class="card">
          <div class="card-header">
            <h3 class="card-title">Users List</h3>
          </div>
          <!-- /.card-header -->
          <div class="card-body">

            <!--Error Message-->
            <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
              {{errorMessage}}
            </div>
            <!--Success Message-->
            <div class="alert alert-success" role="alert" *ngIf="successMessage">
              {{successMessage}}
            </div>

            <table id="example1" class="table table-bordered table-hover">
              <thead>
                <tr>
                    <th>Name</th>
                    <th>Phone Number</th>
                    <th>Email</th>
                    <th>Location</th>
                    <th>Branch</th>
                    <th>Role</th>
                    <th>Stock Access Level</th>
                    <th></th>
                </tr>
              </thead>
              <tbody>
                  <tr  *ngFor="let user of users | searchUser: searchText | paginate: { itemsPerPage: 10, currentPage: page, totalItems: count }">
                      <td>{{user.name}}</td>
                      <td>{{user.phone_no}}</td>
                      <td>{{user.email}}</td>
                      <td>{{user.location_name}}</td>
                      <td>{{user.branch_name}}</td>
                      <td>{{user.role_name}}</td>
                      <td *ngIf="user.stk_access_level === 0">User's Branch</td>
                      <td *ngIf="user.stk_access_level === 1">User's Location</td>
                      <td *ngIf="user.stk_access_level === 2">User's Country</td>
                      <td *ngIf="user.stk_access_level === 3">All Locations</td>
                      <td>
                        <div class="dropdown">
                            <button class="btn btn-default dropdown-toggle" type="button"
                                data-toggle="dropdown">Action
                                <span class="caret"></span></button>
                            <ul class="dropdown-menu">
                                <li><a class="dropdown-item" routerLink="/settings/edit-user/{{user.id}}"><i class="fa fa-edit"></i>&nbsp;Edit</a></li>
                                <li><a class="dropdown-item" routerLink="/settings/change-user-password/{{user.id}}/{{user.name}}"><i class="fa fa-edit"></i>&nbsp;Change Password</a></li>
                                <li><a class="dropdown-item" routerLink="/settings/add-device/{{user.id}}/{{user.name}}"><i class="fa fa-mobile-alt"></i>&nbsp;Add Device</a></li>
                                <li><a class="dropdown-item" href="#" (click)="deleteUser($event,user.id)"><i class="fa fa-trash"></i>&nbsp;Delete</a></li>
                            </ul>
                        </div>
                      </td>
                  </tr>
              </tbody>
            </table>
            <pagination-controls (pageChange)="pageChangeEvent($event)"></pagination-controls>
          </div>
          <!-- /.card-body -->
        </div>
      </div>
    </section>